import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const initialState = {};
export const outletsSlice = createSlice({
    name: 'outlets',
    initialState,
    reducers: {
        outletsCleared: () => {
            return {};
        },
        outletUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        outletDeleted: (state, action) => {
            delete state[action.payload];
        },
        outletsReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.outlets) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const { outletsCleared, outletUpdated, outletDeleted, outletsReplaced } = outletsSlice.actions;
export const outletAdded = outletUpdated;
export default outletsSlice.reducer;
